import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';

const Loader: FC = () => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 430 330">
        <rect x="32" y="34" rx="9" ry="9" width="200" height="20" />
        <rect x="32" y="78" rx="9" ry="9" width="178" height="20" />
        <rect x="32" y="126" rx="9" ry="9" width="138" height="20" />
        <rect x="32" y="174" rx="9" ry="9" width="138" height="20" />
        <rect x="32" y="222" rx="9" ry="9" width="178" height="20" />
        <rect x="32" y="267" rx="9" ry="9" width="200" height="20" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
